import { ApiResource } from '@/core/models/api-resource.interface';
import { StoreState } from '@/core/models/store.interface';
import { candidateMapper } from '@/modules/candidates/mappers/candidate.mapper';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { Candidate } from '../candidates/candidate.interface';
import { Filters } from '../filters/filter.interface';

export interface FormFollowUpState {
   filters?: Filters;
   activeIndex: number;
   query?: LocationQuery;
   overview?: ApiResource<Array<Candidate>>;
}

const FormFollowUpStore: Module<FormFollowUpState, StoreState> = {
   namespaced: true,
   state: {
      activeIndex: 0,
   },
   getters: {},
   mutations: {
      SET_QUERY(state, query: LocationQuery) {
         state.query = query;
      },
      SET_OVERVIEW(state, overview?: ApiResource<Array<Candidate>>) {
         state.overview = overview;
      },
      DELETE_CANDIDATE(state, candidateId: number) {
         if (state.overview) {
            state.overview.data = state.overview.data.filter((c) => c.id !== candidateId);
         }
      },
      UPDATE_CANDIDATE(state, candidate: Candidate) {
         if (state.overview) {
            const index = state.overview!.data.findIndex((c) => c.id === candidate.id);

            if (state.overview.data[index]) {
               const listCandidate = state.overview.data[index];
               const candidateFromServer = candidateMapper(candidate);

               const updatedCandidate = deepMergeObject(listCandidate, candidateFromServer);
               state.overview.data.splice(index, 1, updatedCandidate);
            }
         }
      },
   },
   actions: {},
};

export default FormFollowUpStore;
